var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTie = function SvgTie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "tie_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.076 4h25.848L39.22 16.833H24.78zm4.686 17.5-6.013 24.049L32 59.799l14.25-14.25L40.24 21.5z",
    clipRule: "evenodd"
  })));
};
export { SvgTie as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5LjA3NjQgNEg0NC45MjM5TDM5LjIyMDMgMTYuODMzM0gyNC43ODAxTDE5LjA3NjQgNFpNMjMuNzYxNyAyMS41TDE3Ljc0OTQgNDUuNTQ5TDMyIDU5Ljc5OThMNDYuMjUwOSA0NS41NDlMNDAuMjM4NiAyMS41SDIzLjc2MTdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";